export default "__VITE_ASSET__7fa46603__"